import { createBrowserRouter } from "react-router";
import { StoreShell } from "./components/Shell.tsx";
import { AccountPage, AuthCallbackPage } from "./routes/account.tsx";
import { BagPage } from "./routes/bag.tsx";
import { HomePage } from "./routes/home.tsx";
import { LegalNoticePage, PrivacyPage, TermsPage } from "./routes/legal.tsx";
import { CookiesPage, HelpPage, NotFoundPage } from "./routes/misc.tsx";
import { OrderPage } from "./routes/order.tsx";
import { ProductPage } from "./routes/product.tsx";
import { SharePage } from "./routes/share.tsx";
import { ShopPage } from "./routes/shop.tsx";

/** The admin console is a separate chunk: shoppers never download it. */
const admin = async () => {
  const [shell, dash, orders, catalog, studio, content] = await Promise.all([
    import("./routes/admin/shell.tsx"),
    import("./routes/admin/dashboard.tsx"),
    import("./routes/admin/orders.tsx"),
    import("./routes/admin/catalog.tsx"),
    import("./routes/admin/studio.tsx"),
    import("./routes/admin/content.tsx"),
    import("./styles/admin.css"),
  ]);
  return { shell, dash, orders, catalog, studio, content };
};
const templateEditor = async () => {
  await admin();
  return import("./routes/admin/template-edit.tsx");
};

export const router = createBrowserRouter([
  {
    element: <StoreShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "shop", element: <ShopPage /> },
      { path: "p/:slug", element: <ProductPage /> },
      {
        path: "make",
        lazy: async () => ({ Component: (await import("./routes/studio.tsx")).StudioPage }),
      },
      { path: "d/:shareId", element: <SharePage /> },
      { path: "bag", element: <BagPage /> },
      {
        path: "checkout",
        lazy: async () => ({ Component: (await import("./routes/checkout.tsx")).CheckoutPage }),
      },
      { path: "orders/:id", element: <OrderPage /> },
      { path: "account", element: <AccountPage /> },
      { path: "auth/callback", element: <AuthCallbackPage /> },
      { path: "help", element: <HelpPage /> },
      { path: "cookies", element: <CookiesPage /> },
      { path: "terms", element: <TermsPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "legal", element: <LegalNoticePage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  {
    path: "admin",
    lazy: async () => ({ Component: (await admin()).shell.AdminShell }),
    children: [
      { index: true, lazy: async () => ({ Component: (await admin()).dash.AdminDashboard }) },
      { path: "orders", lazy: async () => ({ Component: (await admin()).orders.AdminOrders }) },
      {
        path: "orders/:id",
        lazy: async () => ({ Component: (await admin()).orders.AdminOrderDetail }),
      },
      { path: "catalog", lazy: async () => ({ Component: (await admin()).catalog.AdminCatalog }) },
      { path: "studio", lazy: async () => ({ Component: (await admin()).studio.AdminStudio }) },
      {
        path: "templates",
        lazy: async () => ({ Component: (await admin()).content.AdminTemplates }),
      },
      {
        path: "templates/:id",
        lazy: async () => ({ Component: (await templateEditor()).AdminTemplateEdit }),
      },
      {
        path: "moderation",
        lazy: async () => ({ Component: (await admin()).content.AdminModeration }),
      },
      { path: "designs", lazy: async () => ({ Component: (await admin()).content.AdminDesigns }) },
      { path: "system", lazy: async () => ({ Component: (await admin()).content.AdminSystem }) },
    ],
  },
]);
